"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Folder = _interopRequireDefault(require("@mui/icons-material/Folder"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SNETButton = _interopRequireDefault(require("../SNETButton"));
var _SNETFileUploadModule = _interopRequireDefault(require("./SNETFileUpload.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileStats = props => {
  const {
    uploadSuccess,
    show,
    fileName,
    fileSize,
    fileDownloadURL,
    error
  } = props;
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETFileUploadModule.default.imgUploaderContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETFileUploadModule.default.uploadDetails
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: uploadSuccess ? _SNETFileUploadModule.default.successfullUpload : _SNETFileUploadModule.default.uploadStatusContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: error ? _SNETFileUploadModule.default.errorField : _SNETFileUploadModule.default.uploadStatusContainer
  }, /*#__PURE__*/_react.default.createElement(_Folder.default, null), /*#__PURE__*/_react.default.createElement(_Typography.default, null, uploadSuccess ? "Files Uploaded Successfully" : "No/Wrong Files Uploaded"))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.title
  }, "File Name:"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.value
  }, fileName)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.title
  }, "Size:"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.value
  }, fileSize)), /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETFileUploadModule.default.uploadBtns
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: fileDownloadURL,
    download: true,
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_SNETButton.default, {
    children: "download files",
    color: "primary",
    variant: "outlined",
    disabled: !uploadSuccess
  })))));
};
FileStats.prototypes = {
  show: _propTypes.default.bool,
  uploadSuccess: _propTypes.default.func,
  fileName: _propTypes.default.func,
  fileSize: _propTypes.default.number,
  fileDownloadURL: _propTypes.default.string
};
var _default = exports.default = FileStats;